export const leadTrackEvent = () => {
  fbq('track', 'Lead')
}
